module.exports = __webpack_public_path__ + "img/file-earmark-ruled.e4439c69.svg";